__turbopack_context__.v({
  "backgroundClick": "CartItem-module__mRrJYG__backgroundClick",
  "blok-big-title": "CartItem-module__mRrJYG__blok-big-title",
  "blok-subtitle": "CartItem-module__mRrJYG__blok-subtitle",
  "blok-title": "CartItem-module__mRrJYG__blok-title",
  "cart-item": "CartItem-module__mRrJYG__cart-item",
  "counter": "CartItem-module__mRrJYG__counter",
  "details": "CartItem-module__mRrJYG__details",
  "discountedPrice": "CartItem-module__mRrJYG__discountedPrice",
  "first-row": "CartItem-module__mRrJYG__first-row",
  "last-row": "CartItem-module__mRrJYG__last-row",
  "name": "CartItem-module__mRrJYG__name",
  "name-container": "CartItem-module__mRrJYG__name-container",
  "variant": "CartItem-module__mRrJYG__variant",
  "wrapper": "CartItem-module__mRrJYG__wrapper",
});
